<!-- nls-rework\src\app\components\loan\pdf-modal\pdf-modal.component.html -->
<mat-dialog-content class="pdf-modal-content">
  @if (pdfUrl) {
    <iframe
      [src]="pdfUrl"
      style="width: 100%; height: 100%; display: block; border: none;"
      frameborder="0"
    ></iframe>
  }
  @if (!pdfUrl) {
    <p>Loading PDF…</p>
  }
</mat-dialog-content>


<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
